var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:(_vm.styles),attrs:{"width":_vm.sizeValue,"height":_vm.sizeValue,"viewBox":_vm.viewboxValue}},[_c('path',{attrs:{"d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }